export default [
    {
      "crop": "Alfalfa",
      "irrigated": 5,
      "dryland": 3.5,
      "units": "tons/ac"
    },
    {
      "crop": "Alfalfa, Seed",
      "irrigated": 600,
      "dryland": 420,
      "units": "lbs/ac"
    },
    {
      "crop": "Alfalfa/Grass, 25:75",
      "irrigated": 5,
      "dryland": 3.5,
      "units": "tons/ac"
    },
    {
      "crop": "Alfalfa/Grass, 50:50",
      "irrigated": 5,
      "dryland": 3.5,
      "units": "tons/ac"
    },
    {
      "crop": "Alfalfa/Grass, 75:25",
      "irrigated": 5,
      "dryland": 3.5,
      "units": "tons/ac"
    },
    {
      "crop": "Asparagus, Field Established",
      "irrigated": 3000,
      "dryland": 2100,
      "units": "lbs/ac"
    },
    {
      "crop": "Asparagus, Field New",
      "irrigated": 3000,
      "dryland": 2100,
      "units": "lbs/ac"
    },
    {
      "crop": "Barley, Feed/Seed",
      "irrigated": 100,
      "dryland": 70,
      "units": "bushels/ac"
    },
    {
      "crop": "Barley, Green Feed/Silage",
      "irrigated": 15,
      "dryland": 10.5,
      "units": "tons/ac"
    },
    {
      "crop": "Barley, Malting",
      "irrigated": 100,
      "dryland": 70,
      "units": "bushels/ac"
    },
    {
      "crop": "Beans, Dry",
      "irrigated": 2500,
      "dryland": 1750,
      "units": "lbs/ac"
    },
    {
      "crop": "Beans, Faba",
      "irrigated": 50,
      "dryland": 35,
      "units": "bushels/ac"
    },
    {
      "crop": "Beans, Fresh",
      "irrigated": 4.5,
      "dryland": 3.2,
      "units": "tons/ac"
    },
    {
      "crop": "Beans, Soy",
      "irrigated": 40,
      "dryland": 28,
      "units": "bushels/ac"
    },
    {
      "crop": "Beets, Sugar",
      "irrigated": 25,
      "dryland": 17.5,
      "units": "tons/ac"
    },
    {
      "crop": "Cabbage",
      "irrigated": 24,
      "dryland": 16.8,
      "units": "tons/ac"
    },
    {
      "crop": "Canola, Commercial",
      "irrigated": 70,
      "dryland": 49,
      "units": "bushels/ac"
    },
    {
      "crop": "Canola, Seed",
      "irrigated": 45,
      "dryland": 31.5,
      "units": "bushels/ac"
    },
    {
      "crop": "Carrots, Field",
      "irrigated": 20,
      "dryland": 14,
      "units": "tons/ac"
    },
    {
      "crop": "Celery, Field",
      "irrigated": 25,
      "dryland": 17.5,
      "units": "tons/ac"
    },
    {
      "crop": "Corn, Grain",
      "irrigated": 160,
      "dryland": 112,
      "units": "bushels/ac"
    },
    {
      "crop": "Corn, Silage",
      "irrigated": 22,
      "dryland": 15.4,
      "units": "tons/ac"
    },
    {
      "crop": "Corn, Sweet",
      "irrigated": 10,
      "dryland": 7,
      "units": "tons/ac"
    },
    {
      "crop": "Flax",
      "irrigated": 55,
      "dryland": 38.5,
      "units": "bushels/ac"
    },
    {
      "crop": "Fruit, Raspberries",
      "irrigated": 4000,
      "dryland": 2800,
      "units": "lbs/ac"
    },
    {
      "crop": "Fruit, Strawberries",
      "irrigated": 7300,
      "dryland": 5110,
      "units": "lbs/ac"
    },
    {
      "crop": "Garden",
      "irrigated": 1000,
      "dryland": 700,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Asparagus Established",
      "irrigated": 75,
      "dryland": 52.5,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Asparagus New",
      "irrigated": 75,
      "dryland": 52.5,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Beans",
      "irrigated": 100,
      "dryland": 70,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Beets",
      "irrigated": 350,
      "dryland": 245,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Blueberries",
      "irrigated": 325,
      "dryland": 227.5,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Broccoli",
      "irrigated": 150,
      "dryland": 105,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Cabbage",
      "irrigated": 1200,
      "dryland": 840,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Cantaloupe",
      "irrigated": 600,
      "dryland": 420,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Carrots",
      "irrigated": 1000,
      "dryland": 700,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Cauliflower",
      "irrigated": 300,
      "dryland": 210,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Celery",
      "irrigated": 1250,
      "dryland": 875,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Corn",
      "irrigated": 400,
      "dryland": 280,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Cucumber",
      "irrigated": 200,
      "dryland": 140,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Garden",
      "irrigated": 1000,
      "dryland": 700,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Garlic",
      "irrigated": 100,
      "dryland": 70,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Kale",
      "irrigated": 1000,
      "dryland": 700,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Lettuce Head",
      "irrigated": 1000,
      "dryland": 700,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Lettuce Leaf",
      "irrigated": 400,
      "dryland": 280,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Lettuce Romaine",
      "irrigated": 1000,
      "dryland": 700,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Melon",
      "irrigated": 375,
      "dryland": 262.5,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Onion",
      "irrigated": 1000,
      "dryland": 700,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Peas",
      "irrigated": 150,
      "dryland": 105,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Potatoes",
      "irrigated": 1000,
      "dryland": 700,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Potatoes Creamer",
      "irrigated": 300,
      "dryland": 210,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Pumpkin",
      "irrigated": 1250,
      "dryland": 875,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Radishes",
      "irrigated": 250,
      "dryland": 175,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Raspberries",
      "irrigated": 100,
      "dryland": 70,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Spinach",
      "irrigated": 300,
      "dryland": 210,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Squash Summer",
      "irrigated": 750,
      "dryland": 525,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Squash Winter",
      "irrigated": 1000,
      "dryland": 700,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Strawberries",
      "irrigated": 180,
      "dryland": 126,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Sweet Potato",
      "irrigated": 300,
      "dryland": 210,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Tomato",
      "irrigated": 500,
      "dryland": 350,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Watermelon",
      "irrigated": 1000,
      "dryland": 700,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garden, Zucchini",
      "irrigated": 750,
      "dryland": 525,
      "units": "lbs/1000sqft"
    },
    {
      "crop": "Garlic",
      "irrigated": 3000,
      "dryland": 2100,
      "units": "lbs/ac"
    },
    {
      "crop": "Grass, Lawn",
      "irrigated": 1,
      "dryland": 0.7,
      "units": "years/acre"
    },
    {
      "crop": "Grass, Sod Commercial",
      "irrigated": 1,
      "dryland": 0.7,
      "units": "years/acre"
    },
    {
      "crop": "Hay Grass, Brome/Fescue/Pasture",
      "irrigated": 5,
      "dryland": 3.5,
      "units": "tons/ac"
    },
    {
      "crop": "Hay Grass, Intensive Grazing",
      "irrigated": 10,
      "dryland": 7,
      "units": "tons/ac"
    },
    {
      "crop": "Hemp Seed",
      "irrigated": 2000,
      "dryland": 1400,
      "units": "lbs/ac"
    },
    {
      "crop": "Lentils",
      "irrigated": 3000,
      "dryland": 2100,
      "units": "lbs/ac"
    },
    {
      "crop": "Lentils",
      "irrigated": 50,
      "dryland": 35,
      "units": "bushels/ac"
    },
    {
      "crop": "Mustard",
      "irrigated": 3000,
      "dryland": 2100,
      "units": "lbs/ac"
    },
    {
      "crop": "Mustard",
      "irrigated": 60,
      "dryland": 42,
      "units": "bushels/ac"
    },
    {
      "crop": "Oats, Seed/Feed/Grain",
      "irrigated": 130,
      "dryland": 91,
      "units": "bushels/ac"
    },
    {
      "crop": "Oats, Silage/Green Feed",
      "irrigated": 12,
      "dryland": 8.4,
      "units": "tons/ac"
    },
    {
      "crop": "Onions, Field",
      "irrigated": 25,
      "dryland": 17.5,
      "units": "tons/ac"
    },
    {
      "crop": "Peas, Chick",
      "irrigated": 1500,
      "dryland": 1050,
      "units": "lbs/acre"
    },
    {
      "crop": "Peas, Dry",
      "irrigated": 50,
      "dryland": 35,
      "units": "bushels/ac"
    },
    {
      "crop": "Peas, Field",
      "irrigated": 50,
      "dryland": 35,
      "units": "bushels/ac"
    },
    {
      "crop": "Peas, Fresh",
      "irrigated": 50,
      "dryland": 35,
      "units": "bushels/ac"
    },
    {
      "crop": "Potatoes, Long Season",
      "irrigated": 25,
      "dryland": 17.5,
      "units": "tons/ac"
    },
    {
      "crop": "Potatoes, Short Season",
      "irrigated": 18,
      "dryland": 12.6,
      "units": "tons/ac"
    },
    {
      "crop": "Pumpkin",
      "irrigated": 25,
      "dryland": 17.5,
      "units": "tons/ac"
    },
    {
      "crop": "Rye",
      "irrigated": 70,
      "dryland": 49,
      "units": "bushels/ac"
    },
    {
      "crop": "Sorghum",
      "irrigated": 130,
      "dryland": 91,
      "units": "bushels/ac"
    },
    {
      "crop": "Squash",
      "irrigated": 9,
      "dryland": 6.3,
      "units": "tons/ac"
    },
    {
      "crop": "Sunflowers",
      "irrigated": 2500,
      "dryland": 1750,
      "units": "lbs/acre"
    },
    {
      "crop": "Timothy, Established",
      "irrigated": 5,
      "dryland": 3.5,
      "units": "tons/ac"
    },
    {
      "crop": "Timothy, New",
      "irrigated": 5,
      "dryland": 3.5,
      "units": "tons/ac"
    },
    {
      "crop": "Trees, Deciduous",
      "irrigated": 10,
      "dryland": 7,
      "units": "trees/1000sqft"
    },
    {
      "crop": "Trees, Evergreen",
      "irrigated": 10,
      "dryland": 7,
      "units": "trees/1000sqft"
    },
    {
      "crop": "Trees, Fruit",
      "irrigated": 10,
      "dryland": 7,
      "units": "trees/1000sqft"
    },
    {
      "crop": "Triticale, Grain",
      "irrigated": 100,
      "dryland": 70,
      "units": "bushels/ac"
    },
    {
      "crop": "Triticale, Hay",
      "irrigated": 4,
      "dryland": 2.8,
      "units": "tons/ac"
    },
    {
      "crop": "Triticale, Silage",
      "irrigated": 16,
      "dryland": 11.2,
      "units": "tons/ac"
    },
    {
      "crop": "Wheat, Durum",
      "irrigated": 100,
      "dryland": 70,
      "units": "bushels/ac"
    },
    {
      "crop": "Wheat, Green Feed",
      "irrigated": 15,
      "dryland": 10.5,
      "units": "tons/ac"
    },
    {
      "crop": "Wheat, Hard Red Spring",
      "irrigated": 80,
      "dryland": 56,
      "units": "bushels/ac"
    },
    {
      "crop": "Wheat, Silage",
      "irrigated": 18,
      "dryland": 12.6,
      "units": "tons/ac"
    },
    {
      "crop": "Wheat, Soft White",
      "irrigated": 100,
      "dryland": 70,
      "units": "bushels/ac"
    },
    {
      "crop": "Wheat, Hard White",
      "irrigated": 80,
      "dryland": 56,
      "units": "bushels/ac"
    },
    {
      "crop": "Wheat, Winter",
      "irrigated": 80,
      "dryland": 56,
      "units": "bushels/ac"
    },
    {
      "crop": "Rhubarb",
      "irrigated": 12,
      "dryland": 8.4,
      "units": "tons/ac"
    },
    {
      "crop": "Canary Seed",
      "irrigated": 40,
      "dryland": 28,
      "units": "bushels/ac"
    },
    {
      "crop": "Shrubs",
      "irrigated": 1,
      "dryland": 0.7,
      "units": "years/acre"
    },
    {
      "crop": "Flowers Low N",
      "irrigated": 1,
      "dryland": 0.7,
      "units": "years/acre"
    },
    {
      "crop": "Flowers Medium N",
      "irrigated": 1,
      "dryland": 0.7,
      "units": "years/acre"
    },
    {
      "crop": "Flowers High N",
      "irrigated": 1,
      "dryland": 0.7,
      "units": "years/acre"
    },
    {
      "crop": "Ryegrass",
      "irrigated": 5,
      "dryland": 3.5,
      "units": "tons/ac"
    }
  ]